var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSandboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5906 14.6558L7.24024 14.264C7.09856 14.2241 7.01887 14.0758 7.05872 13.9341L10.0804 3.52527C10.1203 3.38359 10.2686 3.30389 10.4103 3.34374L11.7606 3.73557C11.9023 3.77541 11.982 3.92373 11.9422 4.06541L8.92044 14.4743C8.87838 14.6159 8.73228 14.6979 8.5906 14.6558ZM6.06697 12.172L7.02994 11.1448C7.13177 11.0364 7.12513 10.8637 7.01223 10.7641L5.00661 8.99977L7.01223 7.23544C7.12513 7.13582 7.13398 6.96316 7.02994 6.85468L6.06697 5.82752C5.96736 5.72126 5.79912 5.71462 5.69064 5.81645L2.50069 8.80496C2.38779 8.909 2.38779 9.08832 2.50069 9.19236L5.69064 12.1831C5.79912 12.2849 5.96736 12.2805 6.06697 12.172ZM13.3102 12.1853L16.5002 9.19457C16.6131 9.09053 16.6131 8.91122 16.5002 8.80717L13.3102 5.81424C13.204 5.71462 13.0357 5.71905 12.9339 5.82531L11.9709 6.85247C11.8691 6.96094 11.8757 7.13361 11.9886 7.23323L13.9943 8.99977L11.9886 10.7641C11.8757 10.8637 11.8669 11.0364 11.9709 11.1448L12.9339 12.172C13.0335 12.2805 13.2018 12.2849 13.3102 12.1853Z",
    fill: "#0BA9E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxIcon);
export default __webpack_public_path__ + "static/media/sandbox-icon.411d92b5f1e1beb37ac22f50c5d353eb.svg";
export { ForwardRef as ReactComponent };